import { RESULT_METRICS } from "../data";
import { Bars } from "./decor";
import { Reveal, SectionLabel } from "./primitives";

export const Results = () => (
  <section id="results" data-testid="results-section" className="relative isolate overflow-hidden bg-white py-24 md:py-32">
    <Bars className="bottom-0 right-6 w-[36%] max-w-md opacity-80" />
    <div className="mx-auto max-w-7xl px-6 md:px-8">
      <Reveal>
        <SectionLabel>Proof & Results</SectionLabel>
        <h2 className="mt-4 max-w-2xl font-serif text-3xl font-medium tracking-tight text-[#23271F] sm:text-4xl lg:text-5xl">
          Outcomes that move the revenue needle.
        </h2>
        <p className="mt-3 text-sm italic text-[#8e9882]">
          Benchmark outcomes from the XSELL GTM transformation methodology.
        </p>
      </Reveal>

      {/* metrics band */}
      <div className="mt-14 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-line bg-line lg:grid-cols-4">
        {RESULT_METRICS.map((m, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <div data-testid={`metric-${i}`} className="h-full bg-white p-8 text-center">
              <p className="font-serif text-4xl font-semibold text-[#5C8A1E] lg:text-5xl">{m.value}</p>
              <p className="mt-2 text-xs uppercase tracking-wider text-[#5f6857]">{m.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
